import type { IStatsRepository } from "@src/domain/stats/repository/stats_repository";
import type { StatsDTO } from "../dto";
import { StatsDtoMapper } from "../mappers/stats-dto.mapper";

/**
 * Get Stats Use Case
 * Retrieves current application statistics
 * 
 * Business Rules:
 * - Returns real-time statistics from the backend
 * - All status counts default to 0 if not present in response
 * - Converts domain value objects to DTOs for presentation layer
 * 
 * This use case acts as the boundary between domain and application layers,
 * using the mapper to convert domain objects to DTOs.
 */
export class GetStatsUseCase {
    constructor(private readonly statsRepository: IStatsRepository) { }

    /**
     * Execute the use case
     * @returns Promise<StatsDTO> - Current application statistics as DTO
     */
    async execute(): Promise<StatsDTO> {
        // Get domain value object from repository
        const stats = await this.statsRepository.getStats();

        // Convert to DTO for application/presentation layer
        return StatsDtoMapper.toDTO(stats);
    }
}
